//
import Model from '@/models/Model'
import DispatchRequestModel from '@/models/Warehouse/WhDispatchRequest'
import DispatchedModel from '@/models/Actions/ADispatched'
import NotReceptionModel from '@/models/Actions/ANotReception'
import PartialReceptionModel from '@/models/Actions/APartialReception'
import ReceiveModel from '@/models/Actions/AReceive'
import ReceptionModel from '@/models/Actions/AReception'
import { DispatchRequestBatchReport } from '@/services/printer'

//
export default class WhDispatchRequestBatch extends Model {
    /**
     *
     */
    wh_selected_dispatch_request_batch = []

    /**
     *
     */
    dispatched() {
        return this.hasMany(DispatchedModel)
    }

    /**
     * the dispatch batch model errors
     */
    static errors = {
        _default: {
            translates: [
                {
                    translate: 'wh_dispatch_requests.',
                    value: 'Solicitud de despacho ',
                },
                {
                    translate: 'El campo wh_dispatch_requests.',
                    value: 'La solicitud ',
                },
                {
                    translate: 'seleccionado',
                    value: 'seleccionada',
                },
            ],
        },
        dispatch_date: {
            name: 'Fecha de despacho',
            translates: [
                {
                    translate: ' dispatch date ',
                    value: ' ',
                },
                {
                    translate: 'de fecha Y-m-d',
                    value: 'Año/Mes/Dia',
                },
                {
                    translate: 'today',
                    value: 'Hoy',
                },
            ],
        },
        wh_dispatch_requests: {
            name: 'Lista de solicitudes de despacho',
            translates: [
                {
                    translate: ' wh dispatch requests ',
                    value: ' ',
                },
            ],
        },
    }

    /**
     * check every ready dispatch request detail
     */
    everyCanDetailDispatch = ({ wh_dispatch_request }) => wh_dispatch_request.g_state_id === 31

    /**
     * check every ready dispatch request detail
     */
    //everyCanDispatch = ({ wh_dispatch_request }) => wh_dispatch_request.sl_sale_invoice_id || wh_dispatch_request.sl_sale_ticket_id
    everyCanDispatch = ({ wh_dispatch_request }) => wh_dispatch_request.g_state_id === 31

    /**
     * check every ready dispatch request detail
     */
    everyCanEdit = ({ wh_dispatch_request }) => wh_dispatch_request.g_state_id < 32 //|| wh_dispatch_request.g_state_id == 40 

    /**
     * get can the dispatch batch dispatch
     */
    get can_dispatch() {
        return (
            this.can_see_dispatch &&
            this.wh_details_dispatch_request_batch.every(this.everyCanDispatch)
        )
    }

    /**
     * get can the dispatch batch dispatch
     */
    get can_dispatched() {
        return (
            this.g_state_id === 26 &&
            this.wh_selected_dispatch_request_batch.every(this.everyCanDispatch)
        )
    }

    /**
     * get can the dispatch batch dispatch
     */
    get can_edit() {
        return this.g_state_id < 27 && this.can_edit_detail
    }

    /**
     * get can edit dispatch request batch detail
     */
    get can_edit_detail() {
        return this.wh_details_dispatch_request_batch.every(this.everyCanEdit)
    }

    /**
     * get can the dispatch batch not reception
     */
    get can_not_reception() {
        return this.g_state_id === 27
    }

    /**
     * get can the dispatch batch partial reception
     */
    get can_partial_reception() {
        return this.g_state_id === 27
    }

    /**
     *
     */
    get can_see_dispatch() {
        return this.g_state_id === 26
    }

    /**
     * get can the dispatch batch reception
     */
    get can_reception() {
        return this.g_state_id > 26 && this.g_state_id !== 28
    }

    /**
     * get new the dispatch batch created at
     */
    get created_at_new() {
        //
        const date = new Date(),
            year = date.getFullYear(),
            month =
                date.getMonth() + 1 < 10
                    ? '0' + (date.getMonth() + 1)
                    : date.getMonth() + 1,
            day = date.getDate()

        //
        return [year, month, day].join('-')
    }

    /**
     * get the dispatch batch state name
     */
    get description_truncate() {
        return this.description.length < 50
            ? this.description
            : this.description.substr(0, 50) + '...'
    }

    /**
     * get the dispatch batch state name
     */
    get g_state_name() {
        return this.g_state ? this.g_state.state : ''
    }

    /**
     * get the dispatch batch state name
     */
    get has_details() {
        return this.wh_details_dispatch_request_batch
    }

    /**
     * get the dispatch batch supervisor full name
     */
    get supervisor_g_user_full_name() {
        //
        if (this.supervisor_g_user && this.supervisor_g_user.hr_employee) {
            return [
                this.supervisor_g_user.hr_employee.names,
                this.supervisor_g_user.hr_employee.last_name1,
                this.supervisor_g_user.hr_employee.last_name2,
            ].join(' ')
        }

        //
        return ''
    }

    /**
     * get the dispatch batch selected length
     */
    get wh_selected_dispatch_request_batch_length() {
        return this.wh_selected_dispatch_request_batch.length
    }

    /**
     * get the dispatch batch detail length
     */
    get wh_details_dispatch_request_batch_length() {
        return this.has_details
            ? this.wh_details_dispatch_request_batch.length
            : 0
    }

    get wh_detail_dispatch_requests_total() {
        return this
            .getProperty('wh_details_dispatch_request_batch', [])
            .reduce(this.reduceDetailTotal, 0)
    }

    /**
     * the dispatch batch includes
     */
    static includes = [
        'g_state',
        'supervisor_g_user.hr_employee',
        'wh_details_dispatch_request_batch.wh_dispatch_request.sl_customer',
        'wh_details_dispatch_request_batch.wh_dispatch_request.sl_customer_branch_offices',
        'wh_details_dispatch_request_batch.wh_dispatch_request.pos_sale.g_seller_user.hr_employee',
        'wh_details_dispatch_request_batch.wh_dispatch_request.pos_sale.payment_types',
        //'wh_details_dispatch_request_batch.wh_dispatch_request.pos_sale.sl_sale_invoice',
        //'wh_details_dispatch_request_batch.wh_dispatch_request.pos_sale.sl_sale_ticket',
        'wh_details_dispatch_request_batch.wh_dispatch_request.g_state',
        'wh_details_dispatch_request_batch.wh_dispatch_request.pch_payment_condition',
        'wh_details_dispatch_request_batch.wh_dispatch_request.wh_detail_dispatch_requests.wh_warehouse',
        'wh_details_dispatch_request_batch.wh_dispatch_request.wh_detail_dispatch_requests.wh_warehouse',
        //'wh_details_dispatch_request_batch.wh_dispatch_request.wh_dispatch_request_document_status',
        'wh_details_dispatch_request_batch.wh_dispatch_request.sl_sale_invoice',
        'wh_details_dispatch_request_batch.wh_dispatch_request.sl_sale_ticket',
    ]

    /**
     * the dispatch batch selected map
     */
    mapDetail = ({ wh_dispatch_request, observation }) => {
        //
        let aux = new DispatchRequestModel(wh_dispatch_request)

        //
        aux.observation = observation
        aux[ 'has_invoice' ] = aux.sl_sale_invoice_id
        aux[ 'has_ticket' ] = aux.sl_sale_ticket_id
        //aux[ 'bill_state_str' ] = aux.has_invoice ? 'Facturado' : aux.has_ticket ? 'Boleteado' : 'Sin Facturar'

        //
        return aux
    }

    /**
     *
     */
    mapReception = item => ({
        observation: String(item.observation),
        g_state_id: Number(item.g_state.id),
        wh_dispatch_request_id: Number(item.id),
    })

    /**
     * the dispatch batch selected map
     */
    mapSelected = ({ id }) => id

    /**
     *
     */
    notReception() {
        return this.hasMany(NotReceptionModel)
    }

    /**
     *
     */
    partialReception() {
        return this.hasMany(PartialReceptionModel)
    }

    /**
     * the dispatch batch report
     */
    print_as_pdf() {
        //
        const body = this.wh_details_dispatch_request_batch.map(detail => [
            detail.wh_dispatch_request.id,
            detail.wh_dispatch_request.created_at.split(' ').shift(),
            detail.wh_dispatch_request.sl_sale_invoice_id ? 'Factura' : detail.wh_dispatch_request.sl_sale_ticket_id ? 'Boleta' : '',
            detail.wh_dispatch_request.sl_sale_invoice ? detail.wh_dispatch_request.sl_sale_invoice.number : detail.wh_dispatch_request.sl_sale_ticket ? detail.wh_dispatch_request.sl_sale_ticket.number : '',
            detail.wh_dispatch_request.sl_customer.rut,
            detail.wh_dispatch_request.sl_customer.business_name,
            //detail.wh_dispatch_request.sl_customer_branch_offices.phone,
            detail.wh_dispatch_request.sl_customer_branch_offices.address,
            '$ ' + detail.wh_dispatch_request.pos_sale.invoice_total,
            detail.wh_dispatch_request.pch_payment_condition.type,
        ])

        //
        const folio = this.id
        const name = this.id

        //
        DispatchRequestBatchReport({ body, name, folio })
    }

    /**
     *
     */
    receive() {
        return this.hasMany(ReceiveModel)
    }

    /**
     *
     */
    reception() {
        return this.hasMany(ReceptionModel)
    }

    /**
     * Reduces the detail total.
     *
     * @param      {<type>}  total   The total
     * @param      {<type>}  item    The item
     * @return     {<type>}  { description_of_the_return_value }
     */
    reduceDetailTotal = (total, item)=> {
        return total += (item.wh_dispatch_request.pos_sale.invoice_total || item.wh_dispatch_request.pos_sale.ticket_total)
    }

    /**
     *
     */
    reset() {
        //
        this.wh_selected_dispatch_request_batch = this.has_details
            ? this.wh_details_dispatch_request_batch.map(this.mapDetail)
            : []

        //
        return this
    }

    /**
     * the dispatch batch endpoint
     */
    resource() {
        return 'wh_dispatch_request_batch'
    }

    /**
     *
     */
    toCreate() {
        //
        this.wh_dispatch_requests = this.wh_selected_dispatch_request_batch.map(
            this.mapSelected
        )

        //
        return this.clean([
            'description',
            'dispatch_date',
            'wh_dispatch_requests',
            'zone',
        ])
    }

    /**
     *
     */
    toReception() {
        //
        this.details = this.wh_selected_dispatch_request_batch.map(
            this.mapReception
        )

        //
        return this.clean(['details'])
    }

    /**
     *
     */
    toUpdate() {
        //
        this.dispatch_date = this.dispatch_date.split(' ').shift()

        //
        this.wh_dispatch_requests = this.wh_selected_dispatch_request_batch.map(
            this.mapSelected
        )

        //
        return this.clean([
            'description',
            'dispatch_date',
            'id',
            'wh_dispatch_requests',
            'zone',
        ])
    }
}
